import { useState, useCallback, useEffect } from 'react'
import { I18n } from 'react-redux-i18n'

import IntegrationAppAPI from 'api/integrationApp'

/**
 * Get Scopes
 * @param {object} params
 * @param {object} params.app
 * @param {'activityApi'|'serviceApi'} params.key
 * @param {'activity_api'|'service_api'} params.name
 *
 * @returns {[
 *  [object],
 *  function,
 *  boolean,
 *  function
 * ]}
 */
const useScopes = ({ app, key, name }) => {
  const [loading, setLoading] = useState(true)
  const [scopes, setScopes] = useState([])


  const getScopes = useCallback(
    async (key, name) => {
      try {
        setLoading(true)

        const result = await IntegrationAppAPI.getScopes({
          types: [name]
        })

        const currentScopes = app[key]?.scopes || []

        setScopes(
          result.map(elem => {
            if (currentScopes.includes(elem.name)) {
              elem.isActive = true
            } else {
              elem.isActive = false
            }

            if (elem.label) {
              elem.description = I18n.t(elem.label)
            }

            return elem
          })
        )

        setLoading(false)
      } catch (error) {
        setLoading(false)
        setScopes([])
      }
    }, []
  )

  useEffect(
    () => {
      getScopes(key, name)
    }, [key, name]
  )

  return [scopes, setScopes, loading, setLoading]
}

export default useScopes
